import React from 'react';
import classNames from 'classnames';
import { LISTING_STATUS } from '../../../constants/listing.constants';
import {
  LISTING_STATE_CLOSED,
  LISTING_STATE_DRAFT,
  LISTING_STATE_PUBLISHED,
} from '../../../util/types';

import css from './ManageListingCard.module.css';
import { FormattedMessage } from 'react-intl';

const LISTING_STATE_TO_LABEL = {
  [LISTING_STATE_DRAFT]: <FormattedMessage id="General.listing.status.draft" />,
  [LISTING_STATE_PUBLISHED]: <FormattedMessage id="General.listing.status.forSale" />,
  [LISTING_STATE_CLOSED]: <FormattedMessage id="General.listing.status.unavailable" />,
};
const LISTING_STATUS_TO_LABEL = {
  [LISTING_STATUS.DRAFT]: LISTING_STATE_TO_LABEL[LISTING_STATE_DRAFT],
  [LISTING_STATUS.FOR_SALE]: LISTING_STATE_TO_LABEL[LISTING_STATE_PUBLISHED],
  [LISTING_STATUS.UNAVAILABLE]: LISTING_STATE_TO_LABEL[LISTING_STATE_CLOSED],
  [LISTING_STATUS.UNDER_NEGOTIATION]: (
    <FormattedMessage id="General.listing.status.underNegotiation" />
  ),
  [LISTING_STATUS.SOLD]: <FormattedMessage id="General.listing.status.sold" />,
  [LISTING_STATUS.CANCELED]: <FormattedMessage id="General.listing.status.canceled" />,
};

const ListingStatus = props => {
  const { currentListing, isSubscriptionExpired = false, isAbsolute = true, className } = props;
  const { state, publicData, metadata } = currentListing?.attributes || {};
  const { status } = publicData || {};
  const { isPaused } = metadata || {};

  const isClosed = state === LISTING_STATE_CLOSED;
  const isDraft = state === LISTING_STATE_DRAFT;
  const isActive = state === LISTING_STATE_PUBLISHED;
  const isSold = status === LISTING_STATUS.SOLD;

  // Priority: sold > subscription expired > paused > closed > status (forSale/underNegotiation) > state
  const { label, labelClass } = (() => {
    if (isSold) {
      return { label: LISTING_STATUS_TO_LABEL[LISTING_STATUS.SOLD], labelClass: css.soldLabel };
    }
    if (isSubscriptionExpired) {
      return {
        label: <FormattedMessage id="ManageListingCard.subscriptionExpiredLabel" />,
        labelClass: css.expiredSubscriptionLabel,
      };
    }
    if (isPaused) {
      return {
        label: <FormattedMessage id="General.listing.status.paused" />,
        labelClass: css.autoPausedLabel,
      };
    }
    if (isClosed) {
      return { label: LISTING_STATE_TO_LABEL[LISTING_STATE_CLOSED], labelClass: css.closedLabel };
    }
    if (isDraft) {
      return { label: LISTING_STATE_TO_LABEL[LISTING_STATE_DRAFT], labelClass: css.draftLabel };
    }
    if (status) {
      return { label: LISTING_STATUS_TO_LABEL[status], labelClass: css.activeLabel };
    }
    return {
      label: LISTING_STATE_TO_LABEL[state],
      labelClass: isDraft ? css.draftLabel : isActive ? css.activeLabel : css.closedLabel,
    };
  })();

  return (
    <span
      className={classNames(css.stateLabel, css.label, labelClass, {
        [css.relativeLabel]: !isAbsolute,
      }, className)}
    >
      {label}
    </span>
  );
};

export default ListingStatus;
